// ============================================================
// MotionStrip - the table plays motion; this viewer's system asks for less.
//
// The GM's table default for motion is a fallback (plan body-map C2): a
// viewer's own choice always wins. A viewer who never chose follows the
// table, so "Always play" from the GM overrides their system's request for
// reduced motion - which nobody should get without being asked. The strip
// asks once; either answer becomes their own choice and the strip goes.
// ============================================================
import { useMotionDisagrees } from '../hooks/useHoldsStill';
import { setViewerPref } from '../utils/viewerPrefs';
import styles from '../styles/MotionStrip.module.css';
import common from '../styles/common.module.css';

export default function MotionStrip() {
  if (!useMotionDisagrees()) return null;
  return (
    <div className={styles.strip} role="status" data-testid="motion-strip">
      <span>The table plays motion, and your system asks for less.</span>
      <button type="button" className={common.btnSmall} onClick={() => setViewerPref('motion', 'off')}>
        Hold still
      </button>
      <button type="button" className={common.btnSmall} onClick={() => setViewerPref('motion', 'on')}>
        Play it
      </button>
    </div>
  );
}
